export class VehicleStateModel {
    constructor(raw = {}) {
        this.accountId = raw.accountId ?? null;
        this.ambientAirTemperature = raw.ambientAirTemperature ?? null;
        this.averageFuelEconomy = raw.averageFuelEconomy ?? null;
        this.barometer = raw.barometer ?? null;
        this.busType = raw.busType ?? null;
        this.companyId = raw.companyId ?? null;
        this.connectionStatus = raw.connectionStatus ?? null;
        this.coolantLevel = raw.coolantLevel ?? null;
        this.coolantTemperature = raw.coolantTemperature ?? null;
        this.createdAt = raw.createdAt ?? null;
        this.currentGear = raw.currentGear ?? null;
        this.defLevel = raw.defLevel ?? null;
        this.dtc = raw.dtc ?? null;
        this.eldId = raw.eldId ?? null;
        this.eldMac = raw.eldMac ?? null;
        this.eldSn = raw.eldSn ?? null;
        this.eldTimezone = raw.eldTimezone ?? null;
        this.eldType = raw.eldType ?? null;
        this.engineFuelTankTemperature = raw.engineFuelTankTemperature ?? null;
        this.engineHours = raw.engineHours ?? null;
        this.engineHoursComputed = raw.engineHoursComputed ?? null;
        this.engineHoursOffset = raw.engineHoursOffset ?? null;
        this.engineIntercoolerTemperature = raw.engineIntercoolerTemperature ?? null;
        this.engineLoad = raw.engineLoad ?? null;
        this.engineTurboOilTemperature = raw.engineTurboOilTemperature ?? null;
        this.fuelLevel = raw.fuelLevel ?? null;
        this.fuelLevel2 = raw.fuelLevel2 ?? null;
        this.fuelRate = raw.fuelRate ?? null;
        this.fwVer = raw.fwVer ?? null;
        this.heading = raw.heading ?? null;
        this.id = raw.id ?? null;
        this.idleHours = raw.idleHours ?? null;
        this.intakeManifoldTemperature = raw.intakeManifoldTemperature ?? null;
        this.locationLat = raw.locationLat ?? null;
        this.locationLon = raw.locationLon ?? null;
        this.locationSource = raw.locationSource ?? null;
        this.locationState = raw.locationState ?? null;
        this.locationText = raw.locationText ?? null;
        this.locationValid = raw.locationValid ?? null;
        this.malfunctions = raw.malfunctions ?? null;
        this.numberOfDtcPending = raw.numberOfDtcPending ?? null;
        this.odometer = raw.odometer ?? null;
        this.odometerComputed = raw.odometerComputed ?? null;
        this.odometerOffset = raw.odometerOffset ?? null;
        this.oilLevel = raw.oilLevel ?? null;
        this.oilPressure = raw.oilPressure ?? null;
        this.oilTemperature = raw.oilTemperature ?? null;
        this.overriddenVin = raw.overriddenVin ?? null;
        this.photo = raw.photo ?? null;
        this.ptoHours = raw.ptoHours ?? null;
        this.rpm = raw.rpm ?? null;
        this.seatbeltOn = raw.seatbeltOn ?? null;
        this.speed = raw.speed ?? null;
        this.totalFuelUsed = raw.totalFuelUsed ?? null;
        this.totalIdleFuel = raw.totalIdleFuel ?? null;
        this.transmissionOilTemperature = raw.transmissionOilTemperature ?? null;
        this.updatedAt = raw.updatedAt ?? null;
        this.vin = raw.vin ?? null;
    }

    get speedMph() {
        return this.speed != null
            ? Number((this.speed * 0.621371).toFixed(0))
            : null;
    }

    get hasLocation() {
        return !!this.locationLat && !!this.locationLon;
    }
}
